import React, {useState, useCallback, useRef} from "react";
import {Link, useParams} from "react-router-dom";
import Select from "react-select";
import {useDropzone} from 'react-dropzone';

import GenericTemplate from "../../../templates/GenericTemplate";
import {apollo_useStyles, options_upload_state, valueToOption} from "../../../atom/Apollo_styles";
import {
  APOLLO_PROFILE_SYSTEM_OPERATOR,
  APOLLO_GROUP_OPERATOR,
  ApolloPageUsagePermission,
  IsAccountGroupAuth,
} from "../../../atom/Apollo_Authorization";
import {
  post_zeus_draft_csv_upload_path,
  get_zeus_draft_csv_upload_results_path,
  get_zeus_ad_group_path,
  get_zeus_draft_csv_download_path,
  zeus_ad_account,
  get_zeus_campaign_path,
  crassetedit_path,
} from "../../../atom/Apollo_links";
import {ApolloMessage, CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {ApolloContext} from "../../../atom/Apollo_Context";
import {ApolloDataTable} from "../../../atom/Apollo_DataTable";
import {ApolloFileUpload} from "../../../molecule/Apollo_FileUpload";
import {ApolloAxios} from "../../../atom/Apollo_ApiRequest3";

import moment from "moment";

import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import IconButton from "@material-ui/core/IconButton"
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import {DraftCsvUploadResultZeus, ImmunityMessage} from "./CSVUploadModelZeus";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {MUIDataTableColumnDef, SelectableRows} from "mui-datatables";

import {ApolloEventRecord, ItemList} from "../../../atom/Apollo_EventRecord";
import { saveAs } from 'file-saver';

type options_csv_name = {
  value: string
  label: string
}

/**
 * Tab画面パーツ
 */
function a11yProps(index: any) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {children}
    </div>
  );
}

const valueToLabel = function (value: any, options: Array<{ value: any; label: string }>): string {
  let option = options.find(option => option.value === value)
  if (!option) {
    return "";
  } else {
    return option.label;
  }
};

function rand() {
  return Math.round(Math.random() * 20) - 10;
}

/**
 * base64をBlob(csv)に変換する
 * @param {string} base64 - base64文字列
 * @returns {Blob} base64をBlob(csv)に変換した値
 */
function convertBlob(base64: string) {
  var bin = atob(base64.replace(/^.*,/, ''));
  var buffer = new Uint8Array(bin.length);

  for (var i = 0; i < bin.length; i++) {
    buffer[i] = bin.charCodeAt(i);
  }

  try {
    var blob = new Blob([buffer.buffer], {
      type: 'text/csv'
    });
  } catch (e) {
    return false;
  }
  return blob;
}

const OperationCSVUploadZeus: React.FC = () => {
  const {state, dispatch} = React.useContext(ApolloContext);
  const {data, setmsg} = React.useContext(ApolloMessage);
  const {accountgroupid, accountid, platformaccountid} = useParams<{
    accountgroupid: string,
    accountid: string,
    platformaccountid: string
  }>();
  const classes = apollo_useStyles();

  const [tabstate, setTabstate] = useState(0);
  const [binary, setBinary] = useState("");
  const [imageFiles, setImageFiles] = useState("");
  const processing = useRef(false);

	// アカウントグループの権限取得
	const isAccountGroupAuth = IsAccountGroupAuth(Number(accountgroupid), APOLLO_GROUP_OPERATOR);

  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 15,
    breadId: 1,
    queries: [],
    menu: {
      id: 1,
      accountId: platformaccountid,
      accountName: "",
    },
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  // ダウンロード
  const handleDownload = () => {
    if (adgroupDL !== "") {
      let isExists = false;

      adgroups.forEach(function (value: any) {
        if (adgroupDL === value.id) {
          isExists = true;
        }
      });

      if (!isExists) {
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "選択されたキャンペーン配下に広告グループIDが存在しません。"
          }
        });
        return;
      }
    }

    const url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_draft_csv_download_path}/${platformAccountId}?campaign_id=${campaignDL}&group_id=${adgroupDL}`;

    ApolloAxios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      // let response1 = response.data.split(/\n/g);

      // let array1 = [[]];
      // array1.shift();

      // response1.forEach(function (res1: any) {
      //   if (res1 === "") {
      //     return true
      //   }

      //   let response2 = res1.split(",")
      //   array1.push(response2)
      // })

      let csvFileName = `performance_${accountid}_${platformAccountName}`;
      if (campaignDL !== "") {
        csvFileName += "_" + campaignDL
      }
      if (adgroupDL !== "") {
        csvFileName += "_" + adgroupDL
      }
      // console.log(platformAccountName);
      csvFileName += `_${moment().format("YYYYMMDDHHmmss")}.csv`
      // const blob1 = dataToCsvBlob(array1, [])
      const blob = convertBlob(response.data)
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = csvFileName;
      link.click();
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    });
  }

  // const dataToCsvBlob = (data: any[][], header: any[]): Blob => {
  //   const body = data
  //   //const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
  //   const csvData = body?.map(line => line.join(',')).join('\r\n');

  //   const blob = new Blob([csvData], {
  //     type: 'text/csv'
  //   })

  //   return blob
  // }

  // アップロード
  const handelSave = async () => {
    if (processing.current) return;
    processing.current = true;
    let isSuccess = false;
    let targetID = "";
    let targetName = "";

    if (state.current.accountId === 0) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "広告アカウントIDを選択してください"
        }
      });
      processing.current = false;
      return;
    }

    if (!imageFiles) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルを選択してください"
        }
      });
      processing.current = false;
      return;
    }

    const params = new FormData();
    params.append('file', imageFiles[0]);
    params.append('uploadUserId', String(state.userprofile.userId));

    // @ts-ignore
    const file: File = imageFiles[0];

    let itemList: ItemList[] = [
      {
        key: "アップロードファイル名",
        beforeValue: "",
        afterValue: file.name,
      },
    ]
    // 実行時
    ApolloEventRecord({
      eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
      logType: "execute",
      result: "",
      userID: state.userprofile.userId,
      userName: state.userprofile.userName,
      accessToken: state.accesstoken ,
      accountGroupID : state.current.accountGroupId,
      accountGroupName: state.current.accountGroupName,
      accountID : state.current.accountId,
      accountName: state.current.accountName,
      campaignID: "", // キャンペーンID
      campaignName: "", // キャンペーン名
      adGroupID: "", // 広告グループID
      adGroupName: "", // 広告グループ名
      menu: "",
      displayName: "一括処理アップロード(パフォーマンス広告)画面",
      category: "一括処理アップロード",
      actionType: "アップロード",
      targetID: "",
      targetName: "",
      itemList: itemList,
    });

    const url = `${process.env.REACT_APP_API_ENDPOINT}${post_zeus_draft_csv_upload_path}/${platformAccountId}`;

    await ApolloAxios.post(
      url,
      params,
      {
        headers: {
          'Authorization': `Bearer ${state.accesstoken}`,
        }
      }
    ).then((response) => {
      isSuccess = true;
      if (response.data.id) targetID = response.data.id;
      targetName = file.name;
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "info",
          message: "アップロードを受付けました。"
        }
      });
    }).catch(error => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    }).finally(() => {
      // 実行結果
      ApolloEventRecord({
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "result",
        result: isSuccess? "成功" : "失敗",
        userID: state.userprofile.userId,
        userName: state.userprofile.userName,
        accessToken: state.accesstoken ,
        accountGroupID : state.current.accountGroupId,
        accountGroupName: state.current.accountGroupName,
        accountID : state.current.accountId,
        accountName: state.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        menu: "",
        displayName: "一括処理アップロード(パフォーマンス広告)画面",
        category: "一括処理アップロード",
        actionType: "アップロード",
        targetID: targetID,
        targetName: targetName,
        itemList: itemList,
      });

      if (isSuccess) {
        setTimeout(
          function () {
            window.location.reload();
          },
          "2000"
        );
      }

      processing.current = false;
    });
  };

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTabstate(newValue);
  };

/**
 * バイト文字列をBlob(csv)に変換する
 * @param {string} originalString - バイト文字列
 * @returns {Blob} バイト文字列をBlob(csv)に変換した値
 */
 function convertBlob(originalString: string) {
    var bin = atob(originalString);
    var buffer = new Uint8Array(bin.length);

    for (var i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }

    var blob = new Blob([buffer.buffer], {
      type: 'text/csv'
    });
    return blob;
  }

  const downloadCsvFile = async (url: string) => {
    const baseUrl = url.replace(/\?.*$/, "");
    //const link = document.createElement("a");
    //link.href = baseUrl;
    try {
      
      const response = await fetch(baseUrl);
      const blob = await response.blob();
      //link.download = valueToOption(baseUrl, option_csv_names).label;
      saveAs(blob,  valueToOption(url, option_csv_names)?.label);
      //link.click();
    } catch (e) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルダウンロードに失敗しました"
        }
      });
      return;
    }
  }

  
  const downloadErrorCsvFile = async (url: string) => {
    const baseUrl = url.replace(/\?.*$/, "");
    //const link = document.createElement("a");
    //link.href = baseUrl;
    try {
      const response = await fetch(baseUrl);
      const blob = await response.blob();
      saveAs(blob,  valueToOption(url, option_error_csv_names)?.label);
      //link.click();
    } catch (e) {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: "ファイルダウンロードに失敗しました"
        }
      });
      return;
    }
  }

  type ZeusCampaign = {
    id: string,
    name: string,
    adAccountId: string,
  }

  type AdGroup = {
    id: number,
    name: string,
  }

  const [uploadResult, setUploadResult] = useState<DraftCsvUploadResultZeus[]>([]);
  const [campaigns, setCampaigns] = useState<ZeusCampaign[]>([]);
  const [adgroups, setAdgroups] = useState<AdGroup[]>([]);
  const [platformAccountId, setPlatformAccountId] = useState("");
  const [option_csv_names, setOptionCsvNames] = useState<options_csv_name[]>([]);
  const [option_error_csv_names, setOptionErrorCsvNames] = useState<options_csv_name[]>([]);

  const [platformAccountName, setPlatformAccountName] = useState<string>("");

  React.useEffect(() => {
    let accountId = state.current.accountId;
    setPlatformAccountId(platformaccountid);

    var url = `${process.env.REACT_APP_API_ENDPOINT}${zeus_ad_account}${platformaccountid}`;
    ApolloAxios.get(url,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          },
        }).then((response) => {
      setPlatformAccountName(response.data.name)
    }).catch(error => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    });

    url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_campaign_path}?account_id=${platformaccountid}&per_page=9999&page=1&sort=created&direction=desc`;
    ApolloAxios.get(url,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${state.accesstoken}`,
        },
      }).then((response) => {
      setCampaigns(response.data ?? [])
    }).catch(error => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    });

    // CSVアップロード結果
    url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_draft_csv_upload_results_path}/${platformaccountid}?per_page=100&page=1&sort=created&direction=desc`;

    ApolloAxios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      var option_csv_name: options_csv_name[] = [];
      var option_error_csv_name: options_csv_name[] = [];
      response.data?.map(function (result: DraftCsvUploadResultZeus) {
        let csvFileNameBase = `performance_` + platformAccountName;
        if (campaignDL !== "") {
          csvFileNameBase += "_" + campaignDL
        }
        if (adgroupDL !== "") {
          csvFileNameBase += "_" + adgroupDL
        }
        csvFileNameBase += `_${moment(result.createdAt).format("YYYYMMDDHHmmss")}`
        // console.log(csvFileNameBase);
        let csvFileName = csvFileNameBase + `_upload.csv`
        let errorCsvFileName = csvFileNameBase + `_error.csv`
        const option1: options_csv_name = {
          value: result.draftFileUrl,
          label: csvFileName,
        };
        
        option_csv_name.push(option1);
        // console.log(option_csv_name);
        if (result.errorFileUrl !== "") {
          const err_option: options_csv_name = {
            value: result.errorFileUrl,
            label: errorCsvFileName,
          };
          option_error_csv_name.push(err_option);
          // console.log(option_error_csv_name);
          
          setOptionErrorCsvNames(option_error_csv_name);
        }
        setOptionCsvNames(option_csv_name);
      }, [platformAccountName]);

      setUploadResult(response.data);
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    });
  }, [platformAccountName])

  let options_campaign = campaigns.map(campaign => ({
    value: campaign.id,
    label: `${campaign.id}_${campaign.name}`
  }))

  const [campaignDL, setCampaignDL] = useState("");
  const [adgroupDL, setAdgroupDL] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);

  const changeAdgroup = (value1: any) => {
    setAdgroupDL(value1.value)
  };

  const changeCampaign = (value1: any) => {
    setCampaignDL(value1.value)
    setAdgroupDL("")

    // 広告グループ一覧
    let url = `${process.env.REACT_APP_API_ENDPOINT}${get_zeus_ad_group_path}?account_id=${platformAccountId}&campaign_id=${value1.value}&per_page=9999&page=1&sort=created&direction=desc`;

    ApolloAxios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    }).then((response) => {
      if (response.data === null) {
        setAdgroups([]);
      } else {
        setAdgroups(response.data);
      }
      setIsUpdate(!isUpdate)
    }).catch((error) => {
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: error.type,
          message: error.errmsg,
        }
      });
    });
  };

  type adgroup1 = {
    value: number,
    label: string,
  };

  const initAdgroup1: adgroup1[] = [{
    value: 0,
    label: "",
  }]

  let options_adgroup = initAdgroup1;
  if (adgroups !== null) {
    options_adgroup = adgroups.map(adgroup => ({
      value: adgroup.id,
      label: `${adgroup.id}_${adgroup.name}`
    }))
  }

  // テンプレート取得
  const handleDownloadTemplete = () => {
    let link = document.createElement('a');
    link.href = "/csv/zeus/operation_csv_template.csv";
    link.download = "performance_operation_csv_template.csv";
    link.click();
  }

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "id",
      label: "一括処理ID",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "updatedAt",
      label: "アップロード日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return moment(value).format("YYYY-MM-DD");
        },
      }
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return valueToLabel(value, options_upload_state);
        },
      }
    },
    {
      name: "processingCompletionTime",
      label: "処理終了日時",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return moment(value).format("YYYY-MM-DD");
        },
      }
    },
    {
      name: "lastUpdateUserId",
      label: "アップロードユーザーID",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "fileRecordCount",
      label: "全件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "checkOkCount",
      label: "取り込み成功件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "checkNgCount",
      label: "取り込みエラー件数",
      options: {
        filter: false,
        sort: false,
      }
    },
    {
      name: "draftFileUrl",
      label: "アップロード済み入稿CSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadCsvFile(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
    {
      name: "errorFileUrl",
      label: "エラーCSV",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return (
            value
            ? <IconButton aria-label="download" onClick={() => downloadErrorCsvFile(value)}>
              <CloudDownloadIcon/>
            </IconButton>
            : undefined
          );
        },
      }
    },
  ];

  const selectableRows: SelectableRows = 'none';
  const options = {
    filter: false,
    download: false,
    print: false,
    search:false,
    sort: false,
    sortOrder: false,
    viewColumns:false,
    selectableRows: 'none',
    pagination:false,
    jumpToPage: false,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  }

  return (
    <GenericTemplate title="">
      <CustomizedSnackbars/>
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_PROFILE_SYSTEM_OPERATOR}>
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>
        <Tabs value={tabstate} onChange={handleChange} aria-label="creative tabs">
          <Tab label="アップロード" {...a11yProps(0)} />
          <Tab label="入稿CSVアップロード結果一覧" {...a11yProps(1)} />
          <Tab label="入稿CSVダウンロード" {...a11yProps(2)} />
        </Tabs>
        <Grid container justifyContent={"flex-end"}>
          <Link
            to={`${crassetedit_path}zeus/image/${accountgroupid}/${accountid}/${platformaccountid}?type=mu`}
          >
            広告アセット一括アップロード
          </Link>
        </Grid>
        <TabPanel value={tabstate} index={0}>
          <ApolloFileUpload
            setBinary={setBinary}
            setFiles={setImageFiles}
            accept=".csv"
            isMultiple={false}
            handleSave={handelSave}
            handleDownloadTemplete={handleDownloadTemplete}
            immunityMessage={ImmunityMessage}
            processing={processing}
            title={"アップロードファイル"}
            isUploadDisable={!isAccountGroupAuth}
          />
        </TabPanel>
        <TabPanel value={tabstate} index={1}>
          <Card className={classes.root} square variant="outlined">
            <ApolloDataTable
              data={uploadResult}
              columns={columns}
              options={options}
              title=""
            />
          </Card>
        </TabPanel>
        <TabPanel value={tabstate} index={2}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <Card className={classes.root} square variant="outlined" style={{height: "600px"}}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    検索条件
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        広告アカウント(固定）
                      </Typography>
                      <Select
                        value={{
                          label: platformAccountName, value: platformAccountName
                        }}
                        closeMenuOnSelect={true}
                        isDisabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        キャンペーン
                      </Typography>
                      <Select
                        closeMenuOnSelect={true}
                        options={options_campaign}
                        onChange={changeCampaign}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" gutterBottom component="div">
                        広告グループ
                      </Typography>
                      <Select
                        closeMenuOnSelect={true}
                        options={options_adgroup}
                        onChange={changeAdgroup}
                        key={isUpdate ? "Loaded" : "Loading"}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions className={classes.cardaction}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownload}
                    className={classes.button}>
                    ＣＳＶダウンロード
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </TabPanel>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default OperationCSVUploadZeus;
